export function detailLoadFile (state) {
    return state.loadImages
}
